<template>
  <ValidationObserver ref="accountForm">
    <validatable-text-input
        v-test="{ input: 'bankName' }"
        :value="bankAccount.bankName"
        rules="required|max:255"
        :readonly="readonly"
        :label="$t('Наименование кредитной  организации')"
        :hint="$t('Отделение Банка России')"
        persistent-hint
        @input="input('bankName', $event)" />
    <validatable-text-input
        v-test="{ input: 'bik' }"
        :value="bankAccount.bik"
        rules="required|max:9|bik"
        :readonly="readonly"
        :label="$t('БИК')"
        @input="input('bik', $event)"
        @change="bikChanged" />
    <validatable-string-combobox
        v-test="{ input: 'correspondentAccount' }"
        :value="bankAccount.correspondentAccount"
        :rules="{ required: true,
                  min: 20,
                  max: 20,
                  numeric: true ,
                  correspondentAccount: { bik: bankAccount.bik }
        }"
        :items="corAccounts(bankAccount.bik)"
        :readonly="readonly"
        :label="$t('Корреспондентский счет')"
        @input="input('correspondentAccount', $event)" />
    <validatable-text-input
        v-test="{ input: 'personalAccount' }"
        :value="bankAccount.personalAccount"
        :rules="{ required: true,
                  min: 20,
                  max: 20,
                  numeric: true ,
                  personalAccount: { bik: bankAccount.bik }
        }"
        :readonly="readonly"
        :label="$t('Расчетный счет')"
        @input="input('personalAccount', $event)" />
  </ValidationObserver>
</template>

<script>
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableStringCombobox from '@/components/reused/ui/ValidatableStringCombobox.vue'
  import { DICTIONARY_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      ValidatableStringCombobox
    },
    props: {
      bankAccount: {
        type: Object,
        require: true
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        bikDictionary: state => (state[DICTIONARIES.STATE.BIK] || [])
      }),
      bankInfo () {
        return (bik) => {
          return !!bik && bik.length === 9
            ? this.bikDictionary.find(d => d.bik.startsWith(bik))
            : null
        }
      },
      corAccounts () {
        return (bik) => {
          return !!bik && bik.length === 9
            ? this.bankInfo(bik)?.correspondentAccounts || []
            : []
        }
      }
    },
    created () {
      this.getBikDictionary()
    },
    methods: {
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getIdentityDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS
      }),
      input: function (property, value) {
        this.$emit('input', { property, value })
      },
      bikChanged: function (bik) {
        const bankInfo = this.bankInfo(bik)
        if (bankInfo) {
          if (!this.bankAccount.bankName) {
            this.input('bankName', bankInfo.bankName)
          }
        }
      },
      getBikDictionary: async function () {
        try {
          this.isLoading = true
          await this.getIdentityDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.BIK
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      validate: async function () {
        return await this.$refs.accountForm.validate()
      }
    }
  }
</script>
